/* ============================================================
   AUSPSFC — Custom Scripts | BY ClickMouse
   Single global JS file. Load once in theme.liquid before </body>:
   {{ 'custom.js' | asset_url | script_tag }}
   Add new custom components below their own banner.
   ============================================================ */


/* ------------------------------------------------------------
   <giveaway-countdown>  — reusable countdown web component
   Waits for its child tiles before starting, so it works whether
   it's parsed before or after this script loads.
   ------------------------------------------------------------ */
(function () {
  if (customElements.get('giveaway-countdown')) return;

  function parseTarget(raw) {
    if (!raw) return null;
    var v = String(raw).trim();
    if (!v) return null;
    if (/^\d{9,13}$/.test(v)) {
      var n = parseInt(v, 10);
      if (v.length <= 11) n *= 1000;
      var de = new Date(n);
      return isNaN(de.getTime()) ? null : de;
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(v)) v = v + 'T23:59:59';
    var d = new Date(v);
    if (isNaN(d.getTime())) d = new Date(v.replace(' ', 'T'));
    return isNaN(d.getTime()) ? null : d;
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  class GiveawayCountdown extends HTMLElement {
    connectedCallback() {
      this._tries = 0;
      this.setup();
    }

    setup() {
      var daysCell = this.querySelector('[data-cd="days"]');
      if (!daysCell) {
        if (this._tries++ < 60) requestAnimationFrame(this.setup.bind(this));
        return;
      }
      this.cells = {
        days: daysCell,
        hours: this.querySelector('[data-cd="hours"]'),
        minutes: this.querySelector('[data-cd="minutes"]'),
        seconds: this.querySelector('[data-cd="seconds"]')
      };
      this.target = parseTarget(this.dataset.target);
      if (!this.target) { this.hidden = true; return; }
      this.tick();
      this.timer = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    tick() {
      var diff = this.target.getTime() - Date.now();
      if (diff <= 0) { this.finish(); return; }
      var t = Math.floor(diff / 1000);
      if (this.cells.days) this.cells.days.textContent = pad(Math.floor(t / 86400));
      if (this.cells.hours) this.cells.hours.textContent = pad(Math.floor((t % 86400) / 3600));
      if (this.cells.minutes) this.cells.minutes.textContent = pad(Math.floor((t % 3600) / 60));
      if (this.cells.seconds) this.cells.seconds.textContent = pad(t % 60);
    }

    finish() {
      if (this.timer) clearInterval(this.timer);
      this.innerHTML = '<span class="gc__ended"></span>';
      this.querySelector('.gc__ended').textContent = this.dataset.ended || 'Entries closed';
      this.setAttribute('data-state', 'ended');
      this.dispatchEvent(new CustomEvent('countdown:ended', { bubbles: true }));
    }
  }

  customElements.define('giveaway-countdown', GiveawayCountdown);
})();


/* ------------------------------------------------------------
   <giveaway-timer-bar>  — floating widget; dismissible.
   Close hides it for the current page view only.
   ------------------------------------------------------------ */
(function () {
  if (customElements.get('giveaway-timer-bar')) return;

  class GiveawayTimerBar extends HTMLElement {
    connectedCallback() {
      this._tries = 0;
      this.setup();
    }

    setup() {
      var btn = this.querySelector('.gtb__close');
      if (!btn) { if (this._tries++ < 60) requestAnimationFrame(this.setup.bind(this)); return; }
      btn.addEventListener('click', this.dismiss.bind(this));
    }

    dismiss() { this.hidden = true; }
  }

  customElements.define('giveaway-timer-bar', GiveawayTimerBar);
})();


/* ------------------------------------------------------------
   <giveaway-prize-counter>  — counts up from $0 to data-target
   when scrolled into view. Respects reduced-motion.
   ------------------------------------------------------------ */
(function () {
  if (customElements.get('giveaway-prize-counter')) return;

  function fmt(n) { return '$' + Math.round(n).toLocaleString('en-AU'); }
  function ease(t) { return 1 - Math.pow(1 - t, 3); }

  class GiveawayPrizeCounter extends HTMLElement {
    connectedCallback() {
      this._tries = 0;
      this.setup();
    }

    setup() {
      this.numEl = this.querySelector('.gpc__num');
      if (!this.numEl) {
        if (this._tries++ < 60) requestAnimationFrame(this.setup.bind(this));
        return;
      }
      this.target = parseInt(String(this.dataset.target).replace(/[^0-9]/g, ''), 10) || 0;
      this.duration = parseInt(this.dataset.duration, 10);
      if (isNaN(this.duration)) this.duration = 2000;

      if (!('IntersectionObserver' in window)) { this.run(); return; }
      var self = this;
      this.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { self.run(); self.io.disconnect(); }
        });
      }, { threshold: 0.4 });
      this.io.observe(this);
    }

    run() {
      if (this._counted) return;
      this._counted = true;
      var numEl = this.numEl, target = this.target, duration = this.duration;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || duration <= 0) { numEl.textContent = fmt(target); return; }
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        numEl.textContent = fmt(target * ease(p));
        if (p < 1) { requestAnimationFrame(step); }
        else { numEl.textContent = fmt(target); }
      }
      requestAnimationFrame(step);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
  }

  customElements.define('giveaway-prize-counter', GiveawayPrizeCounter);
})();